<template>
  <div
    class="fullscreen-darkener"
    data-testid="modal-darkener"
    tabindex="0"
  />
</template>

<script>
export default {
  name: 'PfDarkener',
}
</script>
